<template>
  <div>
    <div>
      <div v-if="isSurveyLoading">
        <loading></loading>
      </div>
      <div v-else-if="failedToLoad">
        <div class="centered-row">
          <ErrorPage>
            <div slot="header">{{ notFoundHeader }}</div>
            <div slot="message">{{ messageNotFound }}</div>
          </ErrorPage>
        </div>
      </div>
      <div v-else-if="loadedSuccessfully" :class="rtl">
        <div v-if="isSurveyOpen">
          <div v-if="needsPrelim">
            <div class="centered-row">
              <SurveyPrelim></SurveyPrelim>
            </div>
          </div>
          <div v-else-if="needsPrepresentation">
            <div class="centered-row">
              <SurveyPresentation></SurveyPresentation>
            </div>
          </div>
          <div v-else-if="sendToPreOptionalQuestion">
            <div class="centered-row">
              <SurveyPreQuestion></SurveyPreQuestion>
            </div>
          </div>
          <div v-else-if="sendToTheSurvey">
            <div>
              <Survey></Survey>
            </div>
          </div>
          <div v-else-if="sendToPostSurveyPresentation">
            <div class="centered-row">
              <SurveyPostPresentation></SurveyPostPresentation>
            </div>
          </div>
          <div v-else-if="sendToOptionalQuestion">
            <div class="centered-row">
              <SurveyOneMoreThing></SurveyOneMoreThing>
            </div>
          </div>
          <div v-else-if="sendToCompletionPage">
            <div class="centered-row">
              <ErrorPage>
                <div v-if="isProspx" slot="addedLogo">
                  <img src="../../../src/assets/images/prospx.png" width="300" />
                </div>
                <div slot="header">{{ $t('done') }}</div>
                <div slot="message">
                  <div class="check-mark">
                    <Fai :icon="['fas', 'check-circle']" />
                  </div>
                  <span>{{ $t('completionMessage') }}</span>
                </div>
              </ErrorPage>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="spaced">
            <div v-if="isSurveyClosed">
              <div class="centered-row">
                <ErrorPage>
                  <div slot="header">{{ generalHeader }}</div>
                  <div slot="message">{{ messageClosed }}</div>
                </ErrorPage>
              </div>
            </div>
            <div v-if="isSurveyCompleted">
              <div class="centered-row">
                <ErrorPage>
                  <div slot="header">{{ generalHeader }}</div>
                  <div slot="message">{{ messageCompleted }}</div>
                </ErrorPage>
              </div>
            </div>
            <div v-if="isSurveyMissing">
              <div class="centered-row">
                <ErrorPage>
                  <div slot="header">{{ notFoundHeader }}</div>
                  <div slot="message">{{ messageNotFound }}</div>
                </ErrorPage>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  IS_SURVEY_RTL,
  LOADING_COMPLETED_FAILURE,
  LOADING_COMPLETED_SUCCESS,
  LOADING_STARTED,
  SURVEY_CLOSED,
  SURVEY_COMPLETED,
  SURVEY_MISSING,
  SURVEY_OPEN, USER_POSITION_IN_SURVEY
} from '../../services/constants'

import SurveyPrelim from './SurveyPrelim'
import Survey from './Survey'
import ErrorPage from '../views/ErrorPage'
import SurveyOneMoreThing from "./SurveyOneMoreThing"
import SurveyPresentation from './SurveyPresentation'
import SurveyPostPresentation from './SurveyPostPresentation'
import { mapGetters } from "vuex"
import SurveyPreQuestion from "@/components/survey/SurveyPreQuestion.vue";

export default {
  name: 'SurveyContainer',

  components: {
    SurveyPreQuestion,
    SurveyOneMoreThing,
    SurveyPrelim,
    Survey,
    ErrorPage,
    SurveyPresentation,
    SurveyPostPresentation
  },

  computed: {
    ...mapGetters([
      IS_SURVEY_RTL
    ]),
    isSurveyLoading () {
      return this.$store.state.surveyModule.survey.loadingState === LOADING_STARTED
    },
    isRedirectUrl () {
      return this.$store.state.surveyModule.redirectURL && this.$store.state.surveyModule.redirectURL.length > 0
    },
    failedToLoad () {
      return this.$store.state.surveyModule.survey.loadingState === LOADING_COMPLETED_FAILURE
    },
    loadedSuccessfully () {
      return this.$store.state.surveyModule.survey.loadingState === LOADING_COMPLETED_SUCCESS
    },
    getSurveyState () {
      return this.$store.state.surveyModule.survey.data.status
    },
    isSurveyClosed () {
      return this.getSurveyState === SURVEY_CLOSED
    },
    isSurveyCompleted () {
      return this.getSurveyState === SURVEY_COMPLETED
    },
    isSurveyMissing () {
      return this.getSurveyState === SURVEY_MISSING
    },
    isSurveyOpen () {
      return this.getSurveyState === SURVEY_OPEN
    },
    needsPrelim () {
      return this.$store.state.surveyModule.userPositionInSurvey.sendToPrelim
    },
    needsPrepresentation () {
      return this.$store.state.surveyModule.userPositionInSurvey.sendToPrepresentation
    },
    sendToTheSurvey () {
      return this.$store.state.surveyModule.userPositionInSurvey.postPrelimToServer
    },
    sendToPostSurveyPresentation () {
      return this.$store.state.surveyModule.userPositionInSurvey.sendToPostSurveyPresentation
    },
    sendToOptionalQuestion () {
      return this.$store.state.surveyModule.userPositionInSurvey.sendToAdditionalQuestion
    },
    sendToPreOptionalQuestion () {
      return this.$store.state.surveyModule.userPositionInSurvey.sendToPreQuestion
    },
    sendToCompletionPage () {
      return this.$store.state.surveyModule.userPositionInSurvey.sendToCompletedPage
    },
    onCompletionPage() {
      return this.isSurveyOpen && !this.needsPrelim && !this.needsPrepresentation && !this.sendToPreOptionalQuestion && !this.sendToTheSurvey && !this.sendToPostSurveyPresentation && !this.sendToOptionalQuestion && this.sendToCompletionPage
    },
    redirectURL () {
      return this.$store.state.surveyModule.userPositionInSurvey.redirectURL
    },
    generalHeader () {
      return 'THANK YOU FOR YOUR INTEREST IN BIMILEAP'
    },
    messageCompleted () {
      return 'The study has been completed'
    },
    messageClosed () {
      return 'The study has been closed'
    },
    notFoundHeader () {
      return 'NOT FOUND'
    },
    messageNotFound () {
      return 'Survey not found'
    },
    rtl () {
      return { 'rtl': this[IS_SURVEY_RTL] }
    },
    isProspx () {
      return this.$store.state.surveyModule.survey.data.study.brand === "prospx"
    }

  },
  metaInfo () {
    const meta = {}
    if (this.isProspx) {
      meta.title = "ProspX.ai"
      meta.link = [
        { rel: 'icon', href: '/prospx-16x16.png'}
      ]
    }
    return meta
  },
  methods: {
    delayedRedirectFromDonePage () {
      this.$store.dispatch(USER_POSITION_IN_SURVEY, { sendToCompletedPage: false })
    }
  },
  mounted () {
    this.$store.subscribe((mutation, state) => {
      if (Object.values(state.surveyModule.userPositionInSurvey).every(item => item === false)) {
        window.location = state.surveyModule.redirectURL
      }
      if (this.onCompletionPage && this.isProspx && this.isRedirectUrl) {
        setTimeout(this.delayedRedirectFromDonePage, 5000);
      }
    })
  },
}
</script>

<style scoped lang="scss">
@import "../../scss/main";

.check-mark {
  display: inline-block;
  color: $red-2;
  font-size: x-large;
  padding-right: 1%;
}

.rtl {
  direction: rtl;
}
</style>
